import {
    messageFactory,
    widgetMessagesFactory,
} from '@/dashboards-v2/components/widget-message/widget-message-helpers.js';
import { LOADING_STATES } from '@/constants';
import { i18n_t as $t } from '@/utils/i18n';
import npsWidgetImage from '@img/widget-images/nps-widget.png';

export const NPS_MESSAGE_KEYS = Object.freeze({
    NOT_CONFIGURED: 'notConfigured',
    CONFIG_INVALID: 'configInvalid',
    GUIDE_INVALID: 'guideInvalid',
    UPGRADE: 'upgrade',
});

const { NOT_CONFIGURED, CONFIG_INVALID, GUIDE_INVALID, UPGRADE } = NPS_MESSAGE_KEYS;

const { LOADING, EMPTY, NOTIFICATION } = LOADING_STATES;

export function getNpsMessages () {
    return Object.freeze({
        [NOT_CONFIGURED]: messageFactory(
            $t('npsWidgetMessages.Widget not configured'),
            $t('npsWidgetMessages.Please select an NPS survey to get started.'),
            NOTIFICATION,
        ),
        [CONFIG_INVALID]: messageFactory(
            $t('npsWidgetMessages.Invalid configuration'),
            $t('npsWidgetMessages.Please update the settings to continue.'),
            NOTIFICATION,
        ),
        [GUIDE_INVALID]: messageFactory(
            $t('npsWidgetMessages.No NPS survey'),
            $t(
                'npsWidgetMessages.The selected survey appears to have been deleted. Please update the settings to continue.',
            ),
            NOTIFICATION,
        ),
        [UPGRADE]: messageFactory(
            $t('npsWidgetMessages.Net Promoter Score (NPS)'),
            $t(
                'npsWidgetMessages.Understand user sentiment for your app through NPS distribution, trends, verbatim responses, promoter and detractor themes, and usage by score.',
            ),
            null,
            null,
            {
                width: '100',
                height: '60',
                src: npsWidgetImage,
            },
        ),
    });
}

export function getNpsTemplateMessages () {
    return widgetMessagesFactory({
        [LOADING]: messageFactory($t('npsWidgetMessages.Loading...')),
        [EMPTY]: messageFactory(
            $t('npsWidgetMessages.No data available'),
            $t(
                'npsWidgetMessages.Data will appear as visitors respond to the NPS Poll. Consider adjusting any applied filters.',
            ),
        ),
    });
}
